/**
 * Origem Flow: serviço da sincronização bidirecional com o Google Calendar.
 * Modelo conta/vínculo: uma conta Google por usuário, N tabelas conectadas.
 */
export default (client) => {
  return {
    status(tableId, workspaceId = null) {
      const params = new URLSearchParams()
      if (tableId) {
        params.set('table_id', tableId)
      }
      if (workspaceId) {
        params.set('workspace_id', workspaceId)
      }
      const query = params.toString()
      return client.get(`/google-calendar/status/${query ? '?' + query : ''}`)
    },
    authUrl(tableId, dateFieldId, returnPath) {
      const params = new URLSearchParams({
        table_id: tableId,
        date_field_id: dateFieldId,
        return_path: returnPath,
      })
      return client.get(`/google-calendar/auth-url/?${params.toString()}`)
    },
    authUrlConnectAll(workspaceId, returnPath) {
      const params = new URLSearchParams({
        connect_all: '1',
        workspace_id: workspaceId,
        return_path: returnPath,
      })
      return client.get(`/google-calendar/auth-url/?${params.toString()}`)
    },
    connectAllTables(workspaceId) {
      return client.post('/google-calendar/connect-all-tables/', {
        workspace_id: workspaceId,
      })
    },
    connectTable(tableId, dateFieldId) {
      return client.post('/google-calendar/connect-table/', {
        table_id: tableId,
        date_field_id: dateFieldId,
      })
    },
    disconnectTable(tableId) {
      return client.post('/google-calendar/disconnect-table/', {
        table_id: tableId,
      })
    },
    setDefaultTable(tableId) {
      return client.post('/google-calendar/default-table/', {
        table_id: tableId,
      })
    },
    disconnectAccount() {
      return client.post('/google-calendar/disconnect/')
    },
    meetings(from, to, tzOffset) {
      const params = new URLSearchParams({
        from,
        to,
        tz_offset: tzOffset,
      })
      return client.get(`/google-calendar/meetings/?${params.toString()}`)
    },
  }
}
